import z from 'zod';
import { getLocales, getLocale, LocaleKey } from '@raisin/cp-utils';

const AppLocales = getLocales() as LocaleKey[];
const [firstAppLocale, ...restAppLocale] = AppLocales;
export const AppLocaleSchema = z.enum([firstAppLocale, ...restAppLocale]);
export type AppLocale = z.infer<typeof AppLocaleSchema>;

const [firstCsLocale, ...restCsLocale] = AppLocales.map(
  (appLocale) => getLocale(appLocale).cmsFormat,
);
export const CsLocaleSchema = z.enum([firstCsLocale, ...restCsLocale]);
export type CsLocale = z.infer<typeof CsLocaleSchema>;

export const AnyLocaleSchema = AppLocaleSchema.or(CsLocaleSchema);
export type AnyLocale = z.infer<typeof AnyLocaleSchema>;
